import React from 'react';
import PropTypes from 'prop-types';
import { MultipleFilter } from 'common/designer-modules/modules/content-library/filters';
import { STATUS_FILTERS } from 'common/designer-modules/siteDesigner';

const MediaFilters = ({
   resources,
   isMobile,
   onFilterChange,
   filters,
   isAuthUser,
   collectionsKey,
}) => {
   return (
      <>
         {
            isAuthUser && (
               <MultipleFilter
                  isMobile={ isMobile }
                  name='Status'
                  data={ STATUS_FILTERS }
                  selectedValue={ filters?.status || [] }
                  filterClassName='intercom-status-filter-member !flex-none'
                  isMultiplSelect
                  onFilterChange={ (value) => {
                     onFilterChange('status', value, true)
                  } }
               />
            )
         }
         <MultipleFilter
            isMobile={ isMobile }
            name='Collections'
            filterNameKey='title'
            filterValueKey='id'
            searchPlaceholder='Search collections'
            data={ resources?.[collectionsKey] || [] }
            selectedValue={ filters?.collections || [] }
            isMultiplSelect
            onFilterChange={ (value) => {
               onFilterChange('collections', value, true)
            } }
         />
         <MultipleFilter
            isMobile={ isMobile }
            name='Models'
            filterNameKey='screen_name'
            filterValueKey='id'
            searchPlaceholder='Search models'
            data={ resources?.cast_members || [] }
            selectedValue={ filters?.casts || [] }
            isMultiplSelect
            onFilterChange={ (value) => {
               onFilterChange('casts', value, true)
            } }
         />
      </>
   )
};

MediaFilters.propTypes = {
   filters: PropTypes.object,
   resources: PropTypes.object,
   onFilterChange: PropTypes.func,
   isAuthUser: PropTypes.bool,
   isMobile: PropTypes.bool,
   collectionsKey: PropTypes.string,
};

export default MediaFilters;
